import React from "react";

import Popup from "components/Popup";

import {
    PopupContainer,
    PopupTitle,
    PopupDescription,
    PopupButtonsContainer,
    PopupButton
} from "../common.styles";

interface ExitPopupProps {
    opened: boolean,
    onConfirm: () => void
    onClose: () => void
}

const ExitPopup = ({opened, onClose, onConfirm}: ExitPopupProps) => {
    return (
        <Popup opened={opened} onClose={onClose}>
            <PopupContainer>
                <PopupTitle>Discard this Job Posting?</PopupTitle>
                <PopupDescription>Details you’ve entered will not be saved.</PopupDescription>
                <PopupButtonsContainer>
                    <PopupButton
                        variant="outlined"
                        onClick={onClose}
                        color="primary"
                        size="large"
                        id="review-button"
                        className="bigButtonInNewStyle"
                    >
                        Keep Editing
                    </PopupButton>
                    <PopupButton
                        variant="contained"
                        onClick={onConfirm}
                        color="primary"
                        size="large"
                        id="review-button"
                        className="bigButtonInNewStyle"
                    >
                        Discard
                    </PopupButton>
                </PopupButtonsContainer>
            </PopupContainer>
        </Popup>
    );
}

export default ExitPopup;
